<template>
  <div>
    <vs-popup fullscreen title="Image Preview" :active.sync="localIsVisible">
      <div>
        <div class="relative flex items-center justify-center">
          <img
            :src="imageUrl"
            style="height: 600px; object-fit: contain !important; width: 800px"
            :style="{
              transform: `scale(${zoomLevel})`,
            }"
            class="object-cover transition-transform duration-300 ease-in-out mx-auto"
          />
          <div class="absolute top-0 right-0 flex space-x-4 m-4">
            <vs-button
              color="dark"
              type="filled"
              icon-pack="feather"
              icon="icon-zoom-in"
              :disabled="zoomLevel > maxZoomInLimit"
              @click="zoomIn"
            >
            </vs-button>
            <vs-button
              color="dark"
              type="filled"
              icon-pack="feather"
              icon="icon-zoom-out"
              @click="zoomOut"
            >
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    imageUrl: {
      type: String,
    },
    maxZoomInLimit: {
      type: Number,
      default: 2,
    },
  },
  watch: {
    isVisible(newVal) {
      this.localIsVisible = newVal;
    },
    localIsVisible(newVal) {
      if (!newVal) {
        this.closeModal();
      }
    },
  },
  data() {
    return {
      zoomLevel: 1,
      localIsVisible: this.isVisible,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    zoomIn() {
      if (this.zoomLevel < this.maxZoomInLimit) this.zoomLevel += 0.1;
    },
    zoomOut() {
      this.zoomLevel = Math.max(1, this.zoomLevel - 0.1);
    },
  },
};
</script>
